module.exports = __webpack_public_path__ + "1.5.0-unryo/img/mesos.3cf38049.png";